import { useFlags } from 'launchdarkly-react-client-sdk';

import { getFraudHeroStatus } from 'utilities/fraudStatus';

const FraudStatusBanner = ({ account }) => {
  const { enableFraudCaseMgrDecommission } = useFlags();
  const heroStatus = getFraudHeroStatus(account?.statuses?.raw);

  if (!enableFraudCaseMgrDecommission || !heroStatus) {
    return null;
  }

  return (
    <div
      style={{
        marginTop: 'calc(var(--spacing) * -1)',
        marginLeft: 'calc(var(--spacing) * -1)',
        marginRight: 'calc(var(--spacing) * -1)',
        padding: 'var(--spacing-xxs)',
        backgroundColor: `var(--red-9)`,
        color: `var(--red-2)`,
        textAlign: 'center',
      }}
    >
      {heroStatus.text}
    </div>
  );
};

export default FraudStatusBanner;
